import { useRef, useCallback } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: 'למה דווקא סקיצה?',
    a: (
      <div className="space-y-3">
        <p>סקיצה היא אב־טיפוס ראשון - פרוטוטייפ על נייר.</p>
        <p>היא הדרך המהירה ביותר להוציא רושם עמום מהראש אל הדף, לפני שהוא נסגר במילים ובהגדרות.</p>
        <p>בתהליך פיתוח היא מופיעה אחרי שלב ה"חלימה", בשלב ה-Ideation - כשהרעיון עדיין לא מוגדר.</p>
        <p>הסקיצה מאפשרת לתת לרעיון צורה ראשונית ולבחון אותו לפני CAD, ולפני כל כלי אחר גם בעידן של AI.</p>
        <p>הייחוד של סקיצה הוא שהיא אינה סגורה ואינה מושלמת.</p>
        <p>וזה בדיוק הכוח שלה.</p>
        <p>במקום לקבע רעיון, היא מחזיקה אותו חי.</p>
        <p>כל קו מזמין המשך, וכל תיקון פותח אפשרות חדשה.</p>
        <p>בניגוד להמחשה פוטוריאליסטית, שלעיתים סוגרת רעיון מוקדם מדי, סקיצה משאירה מקום לחשיבה להתפתח תוך כדי תנועה.</p>
        <p>כך היא מאפשרת לעבור ממושג עמום לצורה ברורה</p>
        <p>מצורה להבנה ומהבנה לרעיון שניתן לדון בו, לפתח אותו ולקבל עליו החלטות.</p>
        <p>זו אינה שאלה של כישרון זו מיומנות.</p>
        <p>לומדים להבין מבנה, פרופורציות וקווי עזר, ומתרגלים עד שהחשיבה עצמה מתחילה לעבוד דרך הקו.</p>
        <p className="font-semibold">מי שיודע לחשוב - יכול ללמוד לחשוב בקו.</p>
      </div>
    ),
  },
  {
    q: "למי הקורס מתאים?",
    a: (
      <div className="space-y-3">
        <p>אם יש לכם רעיון תקוע בראש ואתם מתקשים להוציא אותו בצורה ברורה? הקורס הזה בשבילכם.</p>
        <p>רבים חושבים היטב, אבל ברגע ההסבר הרעיון מתערפל. מילים לא תמיד מספיקות. בהירות נוצרת כשיש צורה.</p>
        <p>סקיצה מדויקת היא הגשר בין מחשבה להסבר ובין הסבר להבנה.</p>
        <p className="font-semibold">הקורס מתאים לכם אם:</p>
        <p>+ יש לכם רעיון טוב בראש, וברגע שצריך להסביר אותו הוא מתפזר.</p>
        <p>+ אתם חושבים: "אין לי כישרון בציור זה בכלל מתאים לי?" כן. כי זה לא קורס ציור זו שיטת חשיבה.</p>
        <p>+ אתם יודעים לצייר, ורוצים להעמיק את ההיגיון המבני והחשיבה דרך סקיצות.</p>
        <p>+ אתם מתחילים לימודי עיצוב, אדריכלות או הנדסה ורוצים להוביל כבר מהיום הראשון עם קו ברור.</p>
        <p>+ אתם סטודנטים שחושבים עמוק, אבל הסקיצה לא משקפת את עומק החשיבה.</p>
        <p>+ אתם מעצבים, נגרים, מהנדסים, אדריכלים או מנהלים שרוצים לבדוק רעיון במהירות על נייר לפני פתיחת CAD.</p>
        <p>+ אתם מובילים צוות, ויודעים שדיונים נמשכים כי אין תרשים ברור שמכריע החלטה.</p>
        <p>+ אתם יזמים או ממציאים שרוצים לדייק רעיון לפני חשיפה והשקעה.</p>
        <p>+ אתם מבינים שהבעיה היא לא כישרון אלא שיטה.</p>
        <p>אם חשוב לכם שהרעיון שלכם יהיה מובן מיד - השיטה הזו עבורכם.</p>
        <p className="font-semibold">הגיע הזמן לחשוב בקו.</p>
      </div>
    ),
  },
  {
    q: "תוך כמה זמן רואים שינוי אמיתי?",
    a: (
      <div className="space-y-3">
        <p>השינוי מתחיל כבר מהתרגולים הראשונים.</p>
        <p>פתאום הקו יציב יותר. המבנה ברור יותר. והחשיבה מתחילה להתמקד.</p>
        <p>אבל השינוי העמוק יותר נבנה בהדרגה - דרך תרגול.</p>
        <p className="font-semibold">הלמידה בנויה כתהליך מדורג:</p>
        <p>דמיון</p>
        <p>← הקרנות של מבטים דו־ממדיים</p>
        <p>← איזומטריה</p>
        <p>← פרספקטיבה</p>
        <p>המסלול מתחיל מדמיון פנימי של הצורה.</p>
        <p>משם עוברים להקרנות בסיסיות מלמעלה, מלפנים ומהצד.</p>
        <p>לאחר מכן לאיזומטריה - ייצוג תלת־ממדי ברור ללא נקודת מבט.</p>
        <p>ולבסוף לפרספקטיבה - שממקמת את האובייקט במרחב אמיתי.</p>
        <p className="font-semibold">כך מתרחש שינוי אמיתי:</p>
        <p>החשיבה עצמה מתחילה לעבוד דרך הקו.</p>
        <p className="font-semibold">כדי להאיץ את התהליך יש לכם גם סוכן AI שמלווה אתכם 24/7:</p>
        <p>מצלמים סקיצה ← מקבלים פידבק מיידי:</p>
        <p>מה לחזק. איפה לדייק ואיך לשפר כבר בסקיצה הבאה. זה מוריד את החשש.</p>
        <p>אתם לא לבד מול הדף -</p>
        <p>אתם מתקדמים מסקיצה לסקיצה בביטחון גדל.</p>
        <p className="font-semibold">והמטרה ברורה:</p>
        <p>לא ציור יפה, אלא סקיצה ברורה שמקדמת החלטות.</p>
      </div>
    ),
  },
  {
    q: "למה דווקא אצלנו?",
    a: (
      <div className="space-y-3">
        <p>כי זו לא עוד טכניקה זו דרך עבודה שאני חי ונושם כבר עשרות שנים.</p>
        <p>מהרישום האינטואיטיבי בתחילת הדרך, דרך קורס מתקדם ברישום מדעי ביד חופשית במילאנו, ועד עבודה בפיתוח מוצרים והובלת תהליכי חדשנות - סקיצה הייתה עבורי כלי מרכזי להבהרת חזון, לדיוק כוונה ולקידום החלטות.</p>
        <p>אני מגיע מהשטח ומהאקדמיה, עם דוקטורט שהתמקד במתודולוגיות Design Thinking.</p>
        <p>את הניסיון הזה תרגמתי לשיטה לוגית, מדורגת וישימה כזו שכל אדם חושב יכול ללמוד.</p>
        <p>לאורך הדרך פגשתי שוב ושוב סטודנטים שאמרו:</p>
        <p>"אני לא יודע", "זה לא בשבילי".</p>
        <p>ובתהליך ברור ראיתי איך החסמים יורדים, הביטחון נבנה — והמשפט משתנה ל־"אה, גם אני יכול".</p>
        <p className="font-semibold">וזה הלב של הקורס:</p>
        <p>לא רק ללמוד לעשות סקיצות, אלא לפתח יכולת לחשוב ולהתבטא בבירור דרך קו.</p>
        <p>זו לא השראה רגעית.</p>
        <p className="font-semibold">זו שיטת עבודה מוכחת שמלמדת לחשוב בקו.</p>
      </div>
    ),
  },
  {
    q: "האם סקיצה עדיין רלוונטית בעידן CAD ו-AI?",
    a: (
      <div className="space-y-3">
        <p>דווקא היום יותר מתמיד.</p>
        <p>לפני תוכנה. לפני אלגוריתם. קודם בהירות.</p>
        <p>סקיצה היא אב־הטיפוס הראשון של הרעיון.</p>
        <p>היא מגיעה לפני מודל תלת־ממד, לפני סטוריבורד ולפני מחוללי תמונות.</p>
        <p>עוד לפני שבונים גיאומטריה או כותבים פרומפט הסקיצה מאפשרת לבדוק במהירות מבנה, יחסים, תנועה והיגיון.</p>
        <p>הכוח שלה הוא שהיא לא סגורה ולא מושלמת. דווקא סקיצה פשוטה משאירה מקום לדמיון ולבדיקת אפשרויות, בעוד שתמונה ריאליסטית עלולה לקבע רעיון מוקדם מדי.</p>
        <p>סקיצה עובדת בעולם של חשיבה חזותית ומרחבית.</p>
        <p>זה הרגע שבו מחשבה הופכת למשהו שאפשר לראות, לשנות ולפתח.</p>
        <p>היא לא רק מתעדת רעיון היא מפתחת אותו: כל קו בודק אפשרות. כל תיקון מחדד כיוון.</p>
        <p>וכשמגיעים ל-CAD או AI, העבודה כבר מדויקת יותר.</p>
        <p>סקיצה מצמצמת ניחושים, חוסכת זמן ומונעת טעויות.</p>
        <p className="font-semibold">סקיצה לא מחליפה את הכלים הדיגיטליים — היא הבסיס שמאפשר להם לעבוד טוב יותר.</p>
      </div>
    ),
  },
];

const FAQSection = () => {
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleValueChange = useCallback((value: string) => {
    if (!value) return;
    const index = parseInt(value.replace("faq-", ""), 10);
    const el = itemRefs.current[index];
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  }, []);

  return (
    <section className="px-6 py-16 md:py-24 bg-muted/50" dir="rtl">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-foreground text-[28px] md:text-4xl font-bold text-center mb-12">
          שאלות נפוצות
        </h2>

        <Accordion type="single" collapsible className="space-y-3" onValueChange={handleValueChange}>
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              ref={(el) => { itemRefs.current[i] = el; }}
              className="bg-card rounded-xl border border-border px-6 shadow-sm scroll-mt-4 transition-colors duration-300 data-[state=open]:bg-primary/5 data-[state=open]:border-primary/30 data-[state=open]:shadow-md"
            >
              <AccordionTrigger className="text-foreground text-base md:text-lg font-semibold text-right hover:no-underline py-5 transition-colors duration-200 data-[state=open]:text-primary">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
